import { render, staticRenderFns } from "./server-create.vue?vue&type=template&id=4aed941d&scoped=true&"
import script from "./server-create.vue?vue&type=script&lang=js&"
export * from "./server-create.vue?vue&type=script&lang=js&"
import style0 from "./server-create.vue?vue&type=style&index=0&id=4aed941d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aed941d",
  null
  
)

export default component.exports